import { Typography } from '@design-system/components/typography/typography';
import * as styles from './CommunitiesV2Page.css';

export const CommunitiesV2Page = () => (
  <div className={styles.wrapper}>
    <Typography variant="body" size="large">
      Communities v2
    </Typography>
  </div>
);
